import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";
import { useLanguage } from "../context/LanguageContext";

import "../styles/Profile.css";
import {
    getUserAppById,
    updateUserApp,
    addSpecialiteToUser,
    removeSpecialiteFromUser,
    addActivityProfToUser,
    removeActivityProfFromUser,
    addActivityTypeToUser,
    removeActivityTypeFromUser
} from "../pages/userapp/ServiceUserApp"

import { getAllWilaya } from "../pages/wilaya/ServiceWilaya";
import { getAllCommuneByWilayaId } from "../pages/commune/ServiceCommune";
import { getAllStatut } from "../pages/statut/ServiceStatut";
import { getSpecialiteByNatureActivityType } from  "../pages/specialite/ServiceSpecialite";
import { getActivityProfByTypeActivityPro } from "../pages/activityprof/ServiceActivityProf";
import { getActivitytypeByCropsOrLivestock } from "../pages/activitytype/ServiceActivityType";
import ProfileHeader from "../components/profile/ProfileHeader";
import PersonalInformationCard from "../components/profile/PersonalInformationCard";
import ProfessionalInformationCard from "../components/profile/ProfessionalInformationCard";
import FarmerInformationCard from "../components/profile/FarmerInformationCard";
import SupplierInformationCard from "../components/profile/SupplierInformationCard";
import ProfileButtonBar from "../components/profile/ProfileButtonBar";

export default function Profile() {

    const { t } = useTranslation();
    const { language } = useLanguage();

    const { id } = useParams();
    const navigate = useNavigate();

    //---------------------------------------------------
    // Etats
    //---------------------------------------------------

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    //---------------------------------------------------
    // Listes
    //---------------------------------------------------

    const [statuts, setStatuts] = useState([]);
    const [specialites, setSpecialites] = useState([]);
    const [activityProfs, setActivityProfs] = useState([]);
    const [activityTypes, setActivityTypes] = useState([]);
    const [wilayas, setWilayas] = useState([]);
    const [communes, setCommunes] = useState([]);
    //---------------------------------------------------
    // Utilisateur
    //---------------------------------------------------

    const [data, setData] = useState({
        id: "",
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        address: "",
        wilayaId: "",
        communeId: "",
        falahOrProf: "",
        natureActivityType: "",
        webSide: "",
        photoUrl: "",
        statutId: "",
        profType: "",
        dateStartActv: "",
        nbAnneesExperience: "",
        experienceYear: "",
        irrigationSystem: false,
        insuranceStatus: false,  
        specialites: [],
        activityProfs: [],
        activityTypes: []


    });

 //---------------------------------------------------
// Chargement des listes
//---------------------------------------------------

const loadLists = async () => {
    try {
        const [
            statutResponse,
            specialiteResponse,
            activityProfResponse,
            activityTypeResponse,
            wilayaResponse,
            CommuneResponse,
        ] = await Promise.all([
            getAllStatut(),
            getSpecialiteByNatureActivityType(),
            getActivityProfByTypeActivityPro(),
            getActivitytypeByCropsOrLivestock(),
            getAllWilaya(),
            getAllCommuneByWilayaId()


        ]);

        setStatuts(statutResponse.data);
        setSpecialites(specialiteResponse.data);
        setActivityProfs(activityProfResponse.data);
        setActivityTypes(activityTypeResponse.data);
        setWilayas(wilayaResponse.data);
        setCommunes(CommuneResponse.data);
        
    }
    catch (error) {
        console.error(error);
        toast.error(t("common.loadListsError"));
    }
};



//---------------------------------------------------
// Chargement utilisateur
//---------------------------------------------------

const loadUser = async () => {
    try {
        setLoading(true);
        const response = await getUserAppById(id);
        const user = response.data;
        //--------------------------------------------------
        // Charger les communes de la wilaya de l'utilisateur
        //--------------------------------------------------
        let communesTemp = [];
        if (user.wilaya?.id) {
            const communeResponse =
                await getAllCommuneByWilayaId(user.wilaya.id);
            communesTemp = communeResponse.data;
            setCommunes(communesTemp);
        }


        let activityProfsTemp = [];
        if (user?.natureActivityType) {
            const activityProfResponse =
                await getActivityProfByTypeActivityPro(user.natureActivityType);
            activityProfsTemp = activityProfResponse.data;
            setActivityProfs(activityProfsTemp);
        }

        let specialitesTemp = [];
        if (user?.natureActivityType) {
            const specialiteResponse =
                await getSpecialiteByNatureActivityType(user.natureActivityType);
            specialitesTemp = specialiteResponse.data;
            setSpecialites(specialitesTemp);
        }

        let activityTypesTemp = [];
        if (user?.falahOrProf) {
            const activityTypeResponse =
                await getActivitytypeByCropsOrLivestock(user.natureActivityType);
            activityTypesTemp = activityTypeResponse.data;
            setActivityTypes(activityTypesTemp);
        }

        //--------------------------------------------------
        // Charger les données du formulaire
        //--------------------------------------------------

        setData({
            id: user.id,
            fullName: user.fullName ?? "",
            email: user.email ?? "",
            password: user.password ?? "",
            phoneNumber: user.phoneNumber ?? "",
            address: user.address ?? "",
            wilayaId: user.wilaya?.id ?? "",
            communeId: user.commune?.id ?? "",
            falahOrProf: user.falahOrProf ?? "",
            natureActivityType: user.natureActivityType ?? "",
              
            webSide: user.webSide ?? "",
            photoUrl: user.photoUrl ?? "",
            statutId: user.statut?.id ?? "",
            profType: user.profType ?? "",
            dateStartActv:
                user.dateStartActv
                    ? user.dateStartActv.substring(0, 10)
                    : "",
            nbAnneesExperience: user.nbAnneesExperience ?? "",        

            experienceYear: user.experienceYear ?? "",
            irrigationSystem: user.irrigationSystem ?? false,
            insuranceStatus: user.insuranceStatus ?? false,
            specialites: user.specialites ?? [],
            activityProfs: user.activityProfs ?? [],
            activityTypes: user.activityTypes ?? []
           

        });

    }
    catch (error) {
        console.error(error);
        toast.error(t("profile.loadError"));
    }
    finally {
        setLoading(false);

    }

};


//---------------------------------------------------
// Initialisation
//---------------------------------------------------

useEffect(() => {
    loadLists();
    loadUser();

}, [id]);



//---------------------------------------------------
// Modification d'un champ
//---------------------------------------------------

const handleChange = async (e) => {

    const { name, value, type, checked } = e.target;

    const newValue =
        type === "checkbox"
            ? checked
            : value;

    // Mise à jour du formulaire
    setData(prev => ({
        ...prev,
        [name]: newValue
    }));

    //-----------------------------------------
    // Wilaya
    //-----------------------------------------

    if (name === "wilayaId") {

        try {

            const response =
                await getAllCommuneByWilayaId(value);
            setCommunes(response.data);
            setData(prev => ({
                ...prev,
                wilayaId: value,
                communeId: ""
            }));

        } catch (error) {

            console.error(error);
        }
    }

    //-----------------------------------------
    // Nature activité  Prof
    //-----------------------------------------

    if (name === "natureActivityType") {
        try {
            const response =
                await getActivityProfByTypeActivityPro(value);
            setActivityProfs(response.data);
            // vider les activités déjà sélectionnées
            setData(prev => ({
                ...prev,
                natureActivityType: value,
                activityProfs: []
            }));

        } catch (error) {

            console.error(error);

        }

    }

    //-----------------------------------------
    // Specialite
    //-----------------------------------------

    if (name === "natureActivityType") {
        try {
            const response =
                await getSpecialiteByNatureActivityType(value);
            setSpecialites(response.data);

            // vider les activités déjà sélectionnées
            setData(prev => ({
                ...prev,
                natureActivityType: value,
                specialites: []
            }));

        } catch (error) {
            console.error(error);
        }

    }

//-----------------------------------------
    // Nature Type activité  
    //-----------------------------------------

    if (name === "natureActivityType") {
        try {
            const response =
                await getActivitytypeByCropsOrLivestock(value);
            setActivityTypes(response.data);
            // vider les activités déjà sélectionnées
            setData(prev => ({
                ...prev,
                falahOrType: value,
                activityTypes: []
            }));
        } catch (error) {
            console.error(error);
        }
    }
};

//---------------------------------------------------
// Photo
//---------------------------------------------------

const handlePhotoChange = (photoUrl) => {
    setData(previous => ({
        ...previous,
        photoUrl
    }));
};

//---------------------------------------------------
// Ajouter une spécialité
//---------------------------------------------------

const handleAddSpecialite = async (specialite) => {
    try {
        await addSpecialiteToUser(data.id, specialite.id);
        setData(previous => ({
            ...previous,
            specialites: [
                ...previous.specialites,
                specialite
            ]
        }));
        toast.success(t("specialite.addSuccess"));

    }
    catch (error) {
        console.error(error);
        toast.error(t("specialite.addError"));
    }
};

//---------------------------------------------------
// Supprimer une spécialité
//---------------------------------------------------

const handleRemoveSpecialite = async (specialite) => {
    try {
        await removeSpecialiteFromUser(
            data.id,
            specialite.id
        );
        setData(previous => ({
            ...previous,
            specialites:
                previous.specialites.filter(
                    item => item.id !== specialite.id
                )
        }));
        toast.success(t("specialite.deleteSuccess"));
    }
    catch (error) {
        console.error(error);
        toast.error(t("specialite.deleteError"));
    }
};

//---------------------------------------------------
// Ajouter activité professionnelle
//---------------------------------------------------

const handleAddActivityProf = async (activityProf) => { 
    try {
        await addActivityProfToUser(
            data.id,
            activityProf.id
        );
        setData(previous => ({
            ...previous,
            activityProfs: [
                ...previous.activityProfs,
                activityProf
            ]
        }));
        toast.success(t("activiteProf.saveSuccess"));
    }
    catch (error) {
        console.error(error);
        toast.error(t("activiteProf.addError"));
    }
};

//---------------------------------------------------
// Supprimer activité professionnelle
//---------------------------------------------------

const handleRemoveActivityProf = async (activityProf) => {
    try {
        await removeActivityProfFromUser(
            data.id,
            activityProf.id
        );
        setData(previous => ({
            ...previous,
            activityProfs:
                previous.activityProfs.filter(
                    item => item.id !== activityProf.id
                )
        }));
        toast.success(t("activiteProf.deleteSuccess"));
    }
    catch (error) {
        console.error(error);
        toast.error(t("activiteProf.deleteError"));
    }
};


//---------------------------------------------------
// Ajouter activité agricole
//---------------------------------------------------

const handleAddActivityType = async (activityType) => {
    try {
        const response = await addActivityTypeToUser(
            data.id,
            activityType.id
        );
        setData(previous => ({
            ...previous,
            activityTypes: [
                ...previous.activityTypes,
                activityType
            ]
        }));

        toast.success(t("activiteType.saveSuccess"));

    } catch (error) {

    }

};

//---------------------------------------------------
// Supprimer activité agricole
//---------------------------------------------------

const handleRemoveActivityType = async (activityType) => {
    try {
        await removeActivityTypeFromUser(
            data.id,
            activityType.id
        );
        setData(previous => ({
            ...previous,
            activityTypes:
                previous.activityTypes.filter(
                    item => item.id !== activityType.id
                )
        }));
        toast.success(t("activiteType.deleteSuccess"));
    }
    catch (error) {
        console.error(error);
        toast.error(t("activiteType.deleteError"));
    }
};

//---------------------------------------------------
// Annuler
//---------------------------------------------------

const handleCancel = () => {
    navigate("/");
};

//---------------------------------------------------
// Sauvegarde
//---------------------------------------------------

//---------------------------------------------------
// Sauvegarde
//---------------------------------------------------

//---------------------------------------------------
// Utilitaire
//---------------------------------------------------

const emptyToNull = (value) => {

    if (
        value === undefined ||
        value === null ||
        value === ""
    ) {

        return null;

    }

    return value;

};



//---------------------------------------------------
// Sauvegarde
//---------------------------------------------------

const handleSubmit = async (event) => {

    event.preventDefault();

    try {
        setSaving(true);
        setErrors({});
        //------------------------------------------------
        // Payload principal
        //------------------------------------------------

        let payload = {
            id: data.id,
            fullName: emptyToNull(
                data.fullName
            ),

            email: emptyToNull(
                data.email
            ),

            password: emptyToNull(
                data.password
            ),

            phoneNumber: emptyToNull(
                data.phoneNumber
            ),

            address: emptyToNull(
                data.address
            ),

            webSide: emptyToNull(
                data.webSide
            ),

            photoUrl: emptyToNull(
                data.photoUrl
            ),

            falahOrProf:
                emptyToNull(
                    data.falahOrProf
                ),

            natureActivityType:
                emptyToNull(
                    data.natureActivityType
                ),

            experienceYear:
                emptyToNull(
                    data.experienceYear
                ),

            irrigationSystem:
                Boolean(
                    data.irrigationSystem
                ),

            insuranceStatus:
                Boolean(
                    data.insuranceStatus
                ),

            dateStartActv:
                emptyToNull(
                    data.dateStartActv
                )

        };


        //------------------------------------------------
        // Statut (NON obligatoire)
        //------------------------------------------------

        if (
            data.statutId &&
            Number(data.statutId) > 0
        ) {

            payload.statut = {
                id:
                    Number(
                        data.statutId
                    )
            };
        }


        //------------------------------------------------
        // Wilaya
        //------------------------------------------------

        if (
            data.wilayaId &&
            Number(data.wilayaId) > 0
        ) {
            payload.wilaya = {
                id:
                    Number(
                        data.wilayaId
                    )
            };

        }


        //------------------------------------------------
        // Commune
        //------------------------------------------------

        if (

            data.communeId &&
            Number(data.communeId) > 0

        ) {

            payload.commune = {

                id:
                    Number(
                        data.communeId
                    )

            };

        }


        //------------------------------------------------
        // Suppression des valeurs nulles
        //------------------------------------------------

        Object.keys(payload)
            .forEach((key) => {

                if (

                    payload[key] === null ||
                    payload[key] === undefined

                ) {

                    delete payload[key];

                }

            });


        //------------------------------------------------
        // Sauvegarde
        //------------------------------------------------

console.log(
    JSON.stringify(
        payload,
        null,
        4
    )
);

        await updateUserApp( payload );
        toast.success(
           t("profile.updateSuccess")
        );
    }

    catch (error) {

        console.error(error);

        toast.error(
             t("common.updateError")
        );

    }

    finally {

        setSaving(false);

    }

};
//---------------------------------------------------
// Affichage
//---------------------------------------------------

return (

    <div className="container py-4">
        {/*==========================================
                Photo + résumé utilisateur
        ==========================================*/}
        <ProfileHeader
            data={data}
            onPhotoChange={handlePhotoChange}
        />
        <form onSubmit={handleSubmit}>

            {/*==========================================
                    Informations personnelles
            ==========================================*/}

            <PersonalInformationCard

                data={data}
                setData={setData}
                errors={errors}
                handleChange={handleChange}
                wilayas={wilayas}
                communes={communes}

            />

            {/*==========================================
                    Professionnel / Fournisseur
            ==========================================*/}
            {
                (data.falahOrProf === "P"|| data.falahOrProf === "S")
                &&
                (
                    <ProfessionalInformationCard
                        data={data}
                        setData={setData}
                        errors={errors}               
                        statuts={statuts}
                        specialites={specialites}
                        activityProfs={activityProfs}
                        handleChange={handleChange}
                        onAddSpecialite={
                            handleAddSpecialite
                        }
                        onRemoveSpecialite={
                            handleRemoveSpecialite
                        }
                        onAddActivityProf={
                            handleAddActivityProf

                        }

                        onRemoveActivityProf={
                            handleRemoveActivityProf
                        }
                    />
                )

            }

            {/*==========================================
                    Fellah
            ==========================================*/}
            {
                data.falahOrProf === "F"
                &&
                (
                    <FarmerInformationCard
                        data={data}
                        setData={setData}
                        errors={errors}
                        handleChange={handleChange}
                        activityTypes={activityTypes}
                        onAddActivityType={
                            handleAddActivityType
                        }
                        onRemoveActivityType={
                            handleRemoveActivityType
                        }
                    />
                )
            }
            {/*==========================================
                    Fournisseur
            ==========================================*/}
            {
                data.falahOrProf === "S"
                &&
                (
                    <SupplierInformationCard
                        data={data}
                        statuts={statuts}
                        errors={errors}
                        handleChange={handleChange}
                    />
                )
            }

            {/*==========================================
                    Boutons
            ==========================================*/}
            <ProfileButtonBar
                saving={saving}
                onCancel={handleCancel}
            />
        </form>
    </div>
)

}







